import { render, staticRenderFns } from "./import_shop.vue?vue&type=template&id=56cedf22&scoped=true"
import script from "./import_shop.vue?vue&type=script&lang=js"
export * from "./import_shop.vue?vue&type=script&lang=js"
import style0 from "./import_shop.vue?vue&type=style&index=0&id=56cedf22&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cedf22",
  null
  
)

export default component.exports